/* global chrome */
import React from 'react';
import { observer } from 'mobx-react';

// Config
import { setToken } from '../../config';

// Translations
import translate from '../Translate.js';

// Dependencies
import { FeatureFlag } from 'react-launch-darkly';

// Components
import SessionStartAutomated from './SessionStartAutomated';

const SessionStart = observer(class SessionStart extends React.Component {
  componentWillMount() {
    const { ExamStore, SessionStore } = this.props.store;

    // Hide the header and footer
    SessionStore.hideHeader = true;
    SessionStore.hideFooter = true;

    // Get session details from sid in query params
    const examSid = this.props.routing.location.query.examSid;
    const sessionSid = this.props.routing.location.query.sessionSid;
    const courseSid = this.props.routing.location.query.courseSid;
    const installSid = this.props.routing.location.query.installSid;
    const token = this.props.routing.location.query.token;

    // If this user is coming from outside of an LMS (like from the DMV)
    // we need to get an installSid and a token from the url and store
    // those for use with exam provisioning.
    if (installSid && token) {
      SessionStore.userData.installSid = installSid;

      sessionStorage.setItem('courseSid', courseSid);
      sessionStorage.setItem('installSid', installSid);
      sessionStorage.setItem('token', token);

      SessionStore.token = token;

      setToken(token, true);

      SessionStore.getExtensionInfo();
    }

    if(examSid && courseSid) {
      ExamStore.getExam(examSid, courseSid);
    }

    if(examSid && sessionSid) {
      ExamStore.getExamSession(examSid, sessionSid);
    }
  }

  renderUninstall = () => {
    const { SessionStore } = this.props.store;
    let forceUninstall = false;

    // If we have not already sent the uninstall message to
    // the extension, send the message, mark it in sessionStorage
    // and set the force uninstall boolean flag to true
    if (!sessionStorage.getItem('extensionUninstalled')) {
      sessionStorage.setItem('extensionUninstalled', true);
      forceUninstall = true;

      chrome.runtime.sendMessage(
        SessionStore.extensionInfo.extensionId,
        { message: 'uninstallExtension' },
        response => console.log(response)
      );
    }
    
    return (
      <div>
        {this.renderView(forceUninstall)}
      </div>
    )
  }

  renderView = forceUninstall => {
    return (
      <FeatureFlag
        flagKey="hybrid"
        renderFeatureCallback={e => this.renderStart(e, forceUninstall)}
        renderDefaultCallback={e => this.renderStart(e, forceUninstall)}
      />
    )
  }

  renderStart = (hybrid, forceUninstall) => {
    const { ExamStore } = this.props.store;

    return (
      <SessionStartAutomated 
        {...this.props}
        exam={ExamStore.exam}
        examSid={ExamStore.exam.configuration.examSid}
        external
        sessionSid={ExamStore.examSession.sid}
        hybrid={hybrid}
        uninstall={forceUninstall ? true : false}
      />
    )
  }

  render() {
    const { SessionStore } = this.props.store;

    if(!SessionStore.loading) {
      return (
        <FeatureFlag
          flagKey="extension-force-uninstall"
          renderFeatureCallback={this.renderUninstall}
          renderDefaultCallback={this.renderView}
        />
      )
    }

    return null;
  }
})

export default translate('SessionStart')(SessionStart);


// WEBPACK FOOTER //
// ./src/app/components/SessionStart/SessionStart.js